// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"styles_loadingWrapper__VSjmE"};